<script setup>
import {computed} from 'vue'
import MiniSurvey from "./MiniSurveyModal.ce.vue";
import {store} from '../store.js'

const props = defineProps({
    locale: {
        type: String,
        default: "nl_NL"
    },
});

store.locale = computed(() => props.locale);
store.fetch.addQuestion(props.locale)
store.fetch.addTranslations(props.locale)

function isReady() {
    return store.fetch.isReady.question && store.fetch.isReady.translations;
}
</script>

<template>
    <MiniSurvey
            v-if="isReady()"
    />
</template>


<style>
@import url("../style.css");

:host {
    /* Reset all CSS properties */
    all: initial;
    color: initial;
    font-family: Open Sans, sans-serif;
}
</style>
